import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { analyticsKeys } from '../analytics.keys';
import { getTopReviewers } from '../analytics.service';
import { FiveMinutes, InitialRetryDelay } from '../constants';
export const useTopReviewers = ({ subdomain = getSubdomain(), startDate, endDate, ...options }) => {
    const q = useQuery({
        refetchInterval: query => (!query.state.data?.isComputed ? InitialRetryDelay : false),
        staleTime: FiveMinutes,
        ...options,
        queryKey: analyticsKeys.topReviewers(subdomain, startDate, endDate),
        queryFn: () => getTopReviewers(subdomain, startDate, endDate),
    });
    return { ...q, isPending: q.isPending || !q.data?.isComputed };
};
